import { connect } from 'react-redux';

import ProductDetailsPrice from './ProductDetailsPrice';
import { State } from '../../../../models/State';

const mapStateToProps = ({
  catalog: { embellishmentsByHash },
}: State) => ({
  embellishmentsByHash,
});

export default connect(mapStateToProps)(ProductDetailsPrice);
